// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterMenuWithPasteValuesButton_wrapper__ZCKbT"};